export const kitUiEn = {
  optional: "Optional",
  cancel: "Cancel",
  confirm: "Confirm",
  delete: "Delete",
  typeToConfirm: "Type {{text}} to confirm",
  confirmTitle: "Please confirm",
  deleteImage: "Delete this image? This cannot be undone.",
  deleteSlot: "Delete this time slot?",
  deleteLineup: "Remove this player from the lineup?",
  deleteAnnouncement: "Delete this announcement?",
  deleteAccountTitle: "Delete your account?",
  deleteAccount: "This cannot be undone. Type DELETE to confirm.",
  cancelSubTitle: "Cancel subscription?",
  cancelSub: "Cancel this subscription at the end of the current period?",
  terminateSubTitle: "Terminate subscription?",
  terminateSub: "This ends the subscription now. Type TERMINATE to confirm.",
  emptyTitle: "Nothing here yet",
  emptyBody: "When there is something to show, it will appear here.",
  noResults: "No results",
  noResultsBody: "Nothing matches these filters.",
  clearFilters: "Clear filters",
  noPermission: "You can't view this",
  noPermissionBody: "Your role does not include this.",
  comingSoon: "Coming soon",
  comingSoonBody: "This is not available yet.",
  errorTitle: "Couldn't load this",
  errorBody: "Check your connection and try again.",
  retry: "Retry",
  report: "Report a problem",
  details: "Technical details",
  loading: "Loading",
  rows: "Rows",
};

export const kitUiMs = {
  optional: "Pilihan",
  cancel: "Batal",
  confirm: "Sahkan",
  delete: "Padam",
  typeToConfirm: "Taip {{text}} untuk sahkan",
  confirmTitle: "Sila sahkan",
  deleteImage: "Padam imej ini? Tindakan ini tidak boleh dibatalkan.",
  deleteSlot: "Padam petak masa ini?",
  deleteLineup: "Keluarkan pemain ini daripada barisan?",
  deleteAnnouncement: "Padam pengumuman ini?",
  deleteAccountTitle: "Padam akaun anda?",
  deleteAccount: "Tindakan ini tidak boleh dibatalkan. Taip DELETE untuk sahkan.",
  cancelSubTitle: "Batalkan langganan?",
  cancelSub: "Batalkan langganan ini pada akhir tempoh semasa?",
  terminateSubTitle: "Tamatkan langganan?",
  terminateSub: "Ini menamatkan langganan sekarang. Taip TERMINATE untuk sahkan.",
  emptyTitle: "Belum ada apa-apa",
  emptyBody: "Apabila ada sesuatu untuk ditunjukkan, ia akan muncul di sini.",
  noResults: "Tiada hasil",
  noResultsBody: "Tiada yang sepadan dengan penapis ini.",
  clearFilters: "Kosongkan penapis",
  noPermission: "Anda tidak boleh melihat ini",
  noPermissionBody: "Peranan anda tidak termasuk ini.",
  comingSoon: "Akan datang",
  comingSoonBody: "Ini belum tersedia.",
  errorTitle: "Tidak dapat dimuatkan",
  errorBody: "Semak sambungan anda dan cuba lagi.",
  retry: "Cuba lagi",
  report: "Laporkan masalah",
  details: "Butiran teknikal",
  loading: "Memuatkan",
  rows: "Baris",
};
